// extracted by mini-css-extract-plugin
export default {"tabContent":"editor_tabContent__wSUdR","textComponent":"editor_textComponent__d4Ap9","callToAction":"editor_callToAction__vbVgt"};